module.exports = __webpack_public_path__ + "static/img/process-pic-3.8e28ace5.png";